import React, { useState, useRef, useEffect } from 'react'

import _ from 'lodash';
import cx from 'classnames';
import { Button } from 'react-bootstrap';
import { isDesktop } from 'react-device-detect';
import Slider from "react-slick";

import './slick.css';
import './slicktheme.css'
import styles from './carousel.module.scss';

const CarouselWidgetComponent = ({ className, style, widgetProps, breakpoint, children, ...rest }) => {

  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');
  const deviceLayout = _.get(widgetProps, `properties.${breakpoint}.layout`);
  const stretched = _.get(widgetProps, 'properties.desktop.stretched', false);
  const free = _.get(widgetProps, 'properties.desktop.free', false);
  const transition = _.get(widgetProps, 'properties.desktop.transition', {});
  const arrowsProperty = _.get(widgetProps, `properties.${breakpoint}.arrows`, {});
  const dotsProperty = _.get(widgetProps, `properties.${breakpoint}.dots`, {});
  
  const [activeIndex, setActiveIndex] = useState(0); // Initialize with the first slide as active
  var widgetStyle = {
    ...style,
    ...getStyles(widgetProps, breakpoint),
  }
  const currentCarouselCard = _.find(children, (child) => { return _.get(child, 'props.widgetProps.order') == (activeIndex + 1); })

  const settings = {
    dots: _.get(dotsProperty, 'flag'),
    autoplay: _.get(transition, 'autoPlay'),
    pauseOnHover: _.get(transition, 'pauseOnHover'),
    autoplaySpeed: (parseInt(_.get(transition, 'visibleDuration')) * 1000),
    appendDots: dots => (
      <div
        style={{ bottom: `${_.get(dotsProperty, 'offset', 10)}px` }}
        className={cx('swiper-pagination', styles.paginationContainer)}
      >
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </div>
    ),
    customPaging: function (index) {
      return (
        <a>
          <span key={index}>
            {renderDotsIcons(dotsProperty, index, (index === activeIndex), (_.size(children) - 1))}
          </span>
        </a>
      );
    },
    swipe: (!isDesktop),
    swipeToSlide: true,
    fade: _.get(transition, 'style') == 'FADE',
    infinite: _.get(transition, 'autoPlay'),
    arrows: _.get(arrowsProperty, 'enabled'),
    speed: (parseInt(_.get(transition, 'speed')) * 1000),
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: function(index, newIndex) {
      setActiveIndex(newIndex);
    },
    dotsClass: "slick-dots slick-thumb",
    nextArrow: <CustomNavigationButton
      arrowsProperty={arrowsProperty}
      breakpoint={breakpoint}
      disable={(!_.get(transition, 'autoPlay') && _.get(currentCarouselCard, 'props.widgetProps.order') == _.size(children) )}
      direction={'right'}
    />,
    prevArrow: <CustomNavigationButton
      arrowsProperty={arrowsProperty}
      breakpoint={breakpoint}
      disable={(!_.get(transition, 'autoPlay') && _.get(currentCarouselCard, 'props.widgetProps.order') == 1 )}
      direction={'left'}
    />
  };

  return (
    <div id={id}
      className={cx(className, styles.carouselContainer, {
        [styles.stretched]: stretched,
        [styles.mobile]: breakpoint === 'mobile',
      })}
      style={widgetStyle}
      data-widget-id={id}
      data-widget-type={type}
    >
      <div style={{ width: "100%", height: "100%", position: 'relative' }}>
        <Slider {...settings} className={styles.carousel}>
          {React.Children.map(children, (child) => (
            <div className={styles.cardWrapper}>
              {
                React.cloneElement(child, {
                  parentStyle: style,
                  stretched: stretched
                }, null)
              }
            </div>
          ))}
        </Slider>
      </div>
    </div >
  )
}

// Custom Nav button component
const CustomNavigationButton = ({ arrowsProperty, disable, breakpoint, direction, onClick }) => {

  const [state, setState] = useState({
    buttonState: 'regular',
    buttonStyles: {}
  })
  useEffect(() => {
    updateButtonStyles('regular');
  }, [breakpoint]);

  const updateButtonStyles = (state) => {
    const updatedStyles = getNavigationButtonStyles(direction, arrowsProperty, state);
    setState((prevstate) => {
      return {
        buttonState: state,
        buttonStyles: updatedStyles
      }
    });
  }

  return (
    <Button
      variant="info"
      style={state.buttonStyles}
      onClick={onClick}
      onMouseOver={() => updateButtonStyles('hover')}
      onMouseOut={() => updateButtonStyles('regular')}
      className={cx(
        {["custom-prev-button"]: direction == 'left' }, 
        {["custom-next-button"]: direction == 'right' }, 
        {[styles.navigationDisable]: disable},
        styles.navigationButton)
      }
    >
      {renderArrowIcons(_.get(arrowsProperty, 'style'), direction, arrowsProperty, state.buttonState)}
    </Button>
  )
}

const renderDotsIcons = (data, index, isActive, lastIndex) => {
  const lastPagination = lastIndex == index;

  const dotStyles = _.get(data, 'flag') ? getPaginationStyles(data, isActive, lastPagination) : {}

  var type = _.get(data, 'style') || _.get(data, 'type')
  switch (type) {

    case 'DEFAULT':
      return (
        <i key={index} style={dotStyles} className={cx('cleverstory-pagination-default', styles.paginationIcon)} />
      )

    case 'STANDARD':
      return (
        <i key={index} style={dotStyles} className={cx('cleverstory-pagination-standard', styles.paginationIcon)} />
      )

    default:
      return (
        <i key={index} style={dotStyles} className={cx('cleverstory-pagination-standard', styles.paginationIcon)} />
      )
  }
}

function getPaginationStyles(properties, isActive, lastPagination) {
  var dotIconstyles = {
  };

  if (!properties && !_.get(properties, 'flag')) {
    return dotIconstyles;
  }

  //font-color
  const defaultcolor = _.get(properties, `defaultColor`, null);
  const selectedcolor = _.get(properties, `selectedColor`, null);

  const color = getColorStyles(isActive ? selectedcolor : defaultcolor);
  dotIconstyles = {
    ...dotIconstyles,
    ...color
  }

  //font-size
  const fontSizeString = _.get(properties, 'size', 8);
  var fontSize = 'inherit'
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }

  dotIconstyles['fontSize'] = fontSize;

  //marginRight
  const spaceBetween = _.get(properties, 'cornerRadius', 8);
  var marginRight = 'inherit'
  if (spaceBetween && !lastPagination) {
    marginRight = parseInt(spaceBetween) + 'px';
  }

  dotIconstyles['marginRight'] = marginRight;

  return dotIconstyles;
}

const renderArrowIcons = (type, direction, properties = null, buttonState) => {

  var arrowIconStyles = getArrowStyles(properties, buttonState);

  switch (type) {
    case 'MORDERN':
      return (
        <i style={arrowIconStyles} className={cx({ ['cleverstory-drop-down-left']: direction == 'left' }, { ['cleverstory-drop-down-right']: direction == 'right' })}></i>
      )

    case 'STANDARD':
      return (
        <i style={arrowIconStyles} className={cx({ ['cleverstory-left']: direction == 'left' }, { ['cleverstory-right']: direction == 'right' })}></i>
      )

    case 'DEFAULT':
      return (
        <i style={arrowIconStyles} className={cx({ ['cleverstory-fill-left']: direction == 'left' }, { ['cleverstory-fill-right']: direction == 'right' })}></i>
      )

    default:
      return (
        <i style={arrowIconStyles} className={cx({ ['cleverstory-left']: direction == 'left' }, { ['cleverstory-right']: direction == 'right' })}></i>
      )
  }
}

function getNavigationButtonStyles(direction, properties, active) {
  var styles = {};

  if (!properties) {
    return styles;
  }

  //background
  const backgroundRgb = _.get(properties, `${active}.backgroundColor`, null);
  var background = 'inherit';
  if (backgroundRgb) {
    background = `rgba(${backgroundRgb.r}, ${backgroundRgb.g}, ${backgroundRgb.b}, ${backgroundRgb.a})`;
  }

  styles['backgroundColor'] = background;

  //border
  const border = _.get(properties, 'backgroundCornerRadius', {});
  const borderStyle = getBorderStyles(border);
  styles = {
    ...styles,
    ...borderStyle
  }

  //offset
  const offset = _.get(properties, 'offset');

  if (direction == 'left') {
    styles = {
      ...styles,
      left: parseInt(offset) + 'px'
    }
  }

  if (direction == 'right') {
    styles = {
      ...styles,
      right: parseInt(offset) + 'px'
    }
  }

  return styles;
}

function getArrowStyles(properties, state) {
  var arrowIconstyles = {};

  if (!properties) {
    return arrowIconstyles;
  }

  const deviceProperties = properties;
  const defaultStyles = _.get(deviceProperties, `${state}`, {});

  //font-color
  const colorRgb = _.get(defaultStyles, `color`, null);
  const color = getColorStyles(colorRgb);
  arrowIconstyles = {
    ...arrowIconstyles,
    ...color
  }

  //font-size
  const fontSizeString = _.get(deviceProperties, 'size', null);
  var fontSize = 'inherit'
  if (fontSizeString) {
    fontSize = parseInt(fontSizeString) + 'px';
  }

  arrowIconstyles['fontSize'] = fontSize;

  return arrowIconstyles;
}

function getStyles(widgetProps, breakpoint) {
  const stretched = _.get(widgetProps, 'properties.desktop.stretched', false);
  const free = _.get(widgetProps, 'properties.desktop.free', false);
  const margin = _.get(widgetProps, 'properties.desktop.margin', 0);
  const padding = _.get(widgetProps, `properties.${breakpoint}.padding`, 0);

  var widgetStyles = {
    paddingTop: `${padding}px`,
    paddingBottom: `${padding}px`,
    transformOrigin: 'top',
  }

  if (breakpoint === 'desktop' && !free) {
    widgetStyles = {
      ...widgetStyles,
      width: `1200px`,
      marginLeft: `calc((100% - 1200px) * 0.5)`,
      paddingLeft: `${padding}px`,
      paddingRight: `${padding}px`
    }

    if (stretched) {
      widgetStyles = {
        ...widgetStyles,
        marginLeft: margin,
        width: `calc(100% - 2 * ${margin}px)`,
        left: `calc((100% - 2 * ${margin}px))/2)`
      }
    }
  }

  if (breakpoint === 'mobile') {
    widgetStyles = {
      ...widgetStyles,
      width: '100%',
    }
  }

  return widgetStyles;
}

export function getColorStyles(value) {
  if (!value) {
    return null;
  }

  const colorRgb = value;

  var color = 'inherit';
  if (colorRgb) {
    color = `rgba(${colorRgb.r}, ${colorRgb.g}, ${colorRgb.b}, ${colorRgb.a})`;
  }

  var styles = {
    color: color
  };

  return styles;
}

export function getBorderStyles(value) {
  if (!value) {
    return null;
  }

  var styles = {
    borderRadius: parseInt(value) + 'px'
  };

  return styles;
}

const carouselWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const CarouselWidget = React.memo(CarouselWidgetComponent, carouselWidgetEquals);